import { Price } from './price';
import { Delivery } from './delivery';

export class Calculation {

    public static adapt(value: any) {
        const pad = value['creative.price_and_delivery'];
        const price = Price.adapt(pad.price);
        const delivery = Delivery.adapt(pad.delivery);
        return new Calculation(
            price,
            delivery,
        );
    }

    constructor(
        public price: Price,
        public delivery: Delivery,
    ) { }
}
